import { Reducer } from 'redux'

import { createFeatureSelector, createSelector } from 'modules/store'

import { Operations } from '../operation-action-map'
import * as signalRActions from './signal-r.actions'

import * as fromSignalR from './signal-r.reducer'

export const STORE_ID = 'signalR'

// tslint:disable-next-line:no-empty-interface
export interface SignalRState extends fromSignalR.State {}

export const reducers: Reducer<SignalRState> = fromSignalR.reducer

export const actions = {
  ...signalRActions,
}

export { default as epics } from './signal-r.epic'

// module state selector
export const selectSignalRState = createFeatureSelector<SignalRState>(STORE_ID)

const getOperation = (state: any, operation: Operations) => operation

export const getData = createSelector(selectSignalRState, getOperation, fromSignalR.getSignalRData)
export const getSignalRData = createSelector(selectSignalRState, fromSignalR.getWholeData)



// WEBPACK FOOTER //
// ./src/modules/signal-r/store/index.ts